<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div id="timer">{{ displayTime }}</div>
